export const RESET = 'EXCMCONSENT_LIST_RESET'
export const SET_ITEMS = 'EXCMCONSENT_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMCONSENT_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMCONSENT_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMCONSENT_LIST_TOGGLE_LOADING'
